export default "__VITE_ASSET__BJaE1d_k__"